import { render, staticRenderFns } from "./InputPassengers.vue?vue&type=template&id=2b96a378"
import script from "./InputPassengers.vue?vue&type=script&lang=js"
export * from "./InputPassengers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsExpand: require('/home/forge/ab.farescraper.com/components/IconsExpand.vue').default,InputPassengersCounter: require('/home/forge/ab.farescraper.com/components/InputPassengersCounter.vue').default,AppDropdown: require('/home/forge/ab.farescraper.com/components/AppDropdown.vue').default})
